import React, { FC } from 'react';
import { View, Text, ViewStyle } from 'react-native';
import { scale } from '@components/frame';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import {
  formatSinceTimeWithDayTranslationCase,
  isPhoneNative,
  localTime,
} from '../../../../../../../../../../helpers';
import { is24HourFormat } from '@components/frame';
import { LINE_HORIZONTAL_PADDING } from '@v2/pages/common/constants/base.constants';
import TouchableElement from '@components/common/touchableElement';
import { LineWithTimelineAndTimeProps } from '@v2/pages/batch/details/modules/batch/interfaces';
import BatchTimeLineTrack from '@v2/pages/batch/details/modules/batch/components/BatchTimeLineTrack/BatchTimeLineTrack';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';
import { ActionArrow } from '@components/common/ActionArrow';
import { TimeLineWrapper } from './TimeLineWrapper';
import { styles } from '@v2/pages/batch/details/modules/batch/components/BatchDetailsBlock/styles';

export const LineWithTimelineAndTime: FC<LineWithTimelineAndTimeProps> = ({
  borderStyles,
  rowPaddings,
  rowStyles,
  leftColumnStyles,
  rightColumnStyles,
  menuItemTextStyles,
  name,
  StatusElement,
  C,
  timeValue,
  targetTimeValue,
  TimeLineComponent,
  onPress,
  borderRadiusConfig,
  shouldRunTime,
  withoutTimeline,
  productionBatchId,
  withoutStretchingForContainer,
  layoutForPhone,
  bg,
  startedOn,
  setEvents,
  useSinceLabel,
  testID,
}) => {
  const _rowStyles: ViewStyle = (rowStyles as ViewStyle) ?? { ...styles.rowStylesWithoutPaddings, ...styles.rowPaddings };

  const getStartedAtContent = () => {
    if (!startedOn) return null;
    if (useSinceLabel) {
      return (
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{formatSinceTimeWithDayTranslationCase(startedOn, is24HourFormat)}</Text>
      );
    }
    return (
      <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>
        {i18n.t('Started at')} <Text style={[font['Time 3'], { color: C('Label/Light/Tertiary') }]}>{localTime(startedOn).format('HH:mm')}</Text>
      </Text>
    );
  };

  const startedAtContent = getStartedAtContent();

  return (
    <TouchableElement testID={testID} hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }} onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            borderRadiusConfig,
            {
              backgroundColor: C(onPress ? pressHoverColor(bg) : bg),
              paddingLeft: scale(LINE_HORIZONTAL_PADDING),
            },
          ]}
        >
          <View
            style={[
              borderStyles,
              rowPaddings ?? styles.rowPaddings,
              { gap: scale(10.5), paddingLeft: 0 },
              !withoutStretchingForContainer && { flex: 1 },
            ]}
          >
            <View
              style={[
                rowStyles ?? { ...styles.rowStylesWithoutPaddings, ...styles.rowPaddings },
                { paddingTop: 0, paddingBottom: 0, paddingLeft: 0 },
                onPress && (isPhoneNative || layoutForPhone) && { paddingRight: scale(30) },
              ]}
            >
              <View style={leftColumnStyles ?? styles.leftColumnStyles}>
                <Text style={menuItemTextStyles}>{i18n.t(name)}</Text>
              </View>
              <View style={[rightColumnStyles ?? styles.rightColumnStyles]}>
                <View style={{ alignSelf: 'flex-start' }}>{StatusElement}</View>
              </View>
            </View>
            {!withoutTimeline && (
              <>
                {!TimeLineComponent && (
                  <View style={{ gap: scale(10.5) }}>
                    <View style={{ flex: 1, paddingRight: scale(LINE_HORIZONTAL_PADDING) }}>
                      <BatchTimeLineTrack C={C} productionBatchId={productionBatchId} start={startedOn} setEvents={setEvents} withGaps={false} />
                    </View>
                    <TimeLineWrapper
                      {...{
                        rowStyles: { ..._rowStyles, paddingLeft: 0 },
                        leftColumnStyles,
                        rightColumnStyles,
                        leftContent: startedAtContent,
                      }}
                    >
                      <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
                        <TimeDisplayInStaticFormat {...{ timeValue, C, shouldRunTime }} />
                        {!!targetTimeValue && (
                          <>
                            <Text style={[font['Time 2'], { color: C('Label/Light/Quinary') }]}> / </Text>
                            <TimeDisplayInStaticFormat {...{ timeValue: targetTimeValue, C }} />
                          </>
                        )}
                      </View>
                    </TimeLineWrapper>
                  </View>
                )}
                {TimeLineComponent && TimeLineComponent}
              </>
            )}
            {onPress && <ActionArrow />}
          </View>
        </View>
      )}
    </TouchableElement>
  );
};
